import React, { HTMLProps, memo } from "react";
import classnames from "classnames";
import Element from "src/components/base/element";

interface IProps extends HTMLProps<HTMLElement> {
    className?: string;
    children: React.ReactNode;
}

function Box(props: IProps) {
    const { className, children, ...rest } = props;
    return (
        <Element {...rest} className={classnames("block", className)}>
            {children}
        </Element>
    );
}

export default memo(Box);
